import { useFetch } from "@app/framework/hooks";
import { apiUrls } from "@app/shared";
import { Loading } from "@modules/shared/components";
import { getLocalizedValue } from "@modules/shared/utils";
import { useEffect, useState } from "react";
import { FinancialInformationItem } from "../types";
import { YearsTabs } from "./YearsTabs";

export function FinancialInfoReportsTab() {
  const [filteredReports, setFinancialReports] = useState<
    FinancialInformationItem[]
  >([]);
  const { data, load, isLoading } = useFetch<{
    records: FinancialInformationItem[];
    years: number[];
  }>(apiUrls.financialInformation.annualReports);

  useEffect(() => {
    load().then((data) => {
      setFinancialReports(data?.records || []);
    });
  }, []);

  const handleYearChange = (year: number | null) => {
    if (year === null) {
      setFinancialReports(data?.records || []);
      return;
    }

    const filteredReports =
      data?.records.filter((record) => record.year === year) || [];
    setFinancialReports(filteredReports);
  };

  return (
    <div className="flex animate-fade flex-col gap-8">
      <div className="flex flex-col gap-6 rounded-3xl bg-white p-4 md:gap-8 md:p-8">
        <YearsTabs years={data?.years || []} onChange={handleYearChange} />
        {isLoading ? (
          <Loading />
        ) : (
          <div className="grid grid-cols-[repeat(auto-fill,minmax(220px,1fr))] gap-4">
            {filteredReports?.map((record, index) => (
              <ReportItem key={index} record={record} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

type ReportItemProps = {
  record: FinancialInformationItem;
};

function ReportItem({ record }: ReportItemProps) {
  return (
    <a
      data-fancybox="financial-statements"
      data-src={getLocalizedValue(record.pdf)}
      href={getLocalizedValue(record.pdf)}
      target="_blank"
      rel="noopener noreferrer"
      className="group flex animate-fade cursor-pointer flex-col items-center gap-4 rounded-2xl border border-[#E0E0E0] bg-white p-4 shadow-sm transition-colors duration-300 hover:bg-gray-100"
    >
      <div className="flex flex-col gap-2">
        <p className="text-center font-semibold text-marine">
          {getLocalizedValue(record.title)}
        </p>
      </div>
    </a>
  );
}
